<template>
  <div
    v-if="dataLoaded"
    class="row switcher currency-switch"
  >
    <ul class="currency-switch-list">
      <li
        class="currency-switch-item"
        v-for="item in currencyInfo.items"
        :key="item.id"
      >
        <span
          class="currency"
          :class="{ 'selected': item.selected }"
          data-id="item.id"
          @click="changeCurrency(item.id)"
        >
          {{ item.label }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import netsetNode from 'netsetNode';

export default {
  data() {
    return {
      currencyInfo: {},
      dataLoaded: false
    }
  },
  methods: {
    changeCurrency(id) {
      netsetNode.call('/nodeapi/change_currency', { id: id }).then(function (data) {
        location.reload();
      })
    }
  },
  mounted() {
    const vm = this;
    netsetNode.call('/nodeapi/currency_info').then(function (response) {
      if (response) {
        vm.currencyInfo = response.currencyInfo;
        vm.dataLoaded = true;
      }
    }).catch(function (error) { })
  },
}
</script>

<style scoped lang="scss">
@import "~@stylesheets/sass/base/_mixins.scss";

.currency-switch {
  text-align: center;
  display: inline-block;

  &-list {
    display: inline-block;
    list-style: none;
    margin-left: 0;
  }

  &-item {
    cursor: pointer;

    @include breakpoint("medium-large") {
      display: inline-block;
      margin-right: 10px;

      &::after {
        content: "|";
        margin-left: 10px;
      }

      &:last-of-type::after {
        content: "";
        margin-left: 0;
      }
    }
  }

  .selected {
    font-weight: bold;
  }
}</style>